/* unplugin-vue-components disabled */import { ElAlert as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/alert/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a630d41"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "go-back"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "width100",
  src: "https://athemes.com/wp-content/uploads/fix-wordpress-posts-returning-404-error.jpg",
  alt: ""
}, null, -1));
export default /*#__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {
    const second = ref(5);
    const router = useRouter();
    const goHome = () => {
      router.replace('/home');
    };
    const cutDown = second => {
      const timer = setInterval(() => {
        if (second.value > 0) {
          second.value--;
        } else {
          goHome();
          clearInterval(timer);
        }
      }, 1000);
    };
    onMounted(() => {
      cutDown(second);
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_alert = __unplugin_components_1;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
        type: "warning",
        onClick: goHome
      }, {
        default: _withCtx(() => [_createTextVNode("返回首页")]),
        _: 1
      }), _createVNode(_component_el_alert, {
        class: "marginL20",
        title: `${_unref(second)}s 后，自动退到首页!`,
        type: "warning",
        closable: false
      }, null, 8, ["title"])]), _hoisted_2]);
    };
  }
});